import { getLanguage } from '../localization';
import { IRequest, TRequestHeaders } from './httpClient';

export const createRequest = <D>(baseURL: string, pathname: string, data?: D, queryString?: string): IRequest => {
    return {
        url: queryString ? pathname + queryString : pathname,
        baseURL: baseURL,
        data: data,
    };
};

export const createHeaders = (contentType?: string): TRequestHeaders => {
    return {
        'Content-Language': getLanguage(),
        'Content-Type': contentType ?? 'application/json',
    };
};

export const paginationQuery = (pageNumber?: number, pageSize?: number, filter?: string, concatPagination?: boolean): string => {
    const queryParams: string[] = [];
    if (!!pageNumber) queryParams.push(`pageNumber=${pageNumber}`);
    if (!!pageSize) queryParams.push(`pageSize=${pageSize}`);
    if (!!filter) queryParams.push(`filter=${filter}`);
    return queryParams.length > 0 ? (concatPagination ? '&'.concat(queryParams.join('&')) : '?'.concat(queryParams.join('&'))) : '';
};
